import React, { useState } from 'react';

import { Button } from 'antd';

import { BugReportButton } from '../../shared/BugReportButton/BugReportButton';

import { faHandPointUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

interface ContentProps {
  children: React.ReactNode;
}
export const LandingContent: React.FC<ContentProps> = ({
  children,
}): React.ReactElement => {
  const [scrollBtnVisible, setScrollBtnVisible] = useState(false);
  const toggleVisibleBtn = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 50) {
      setScrollBtnVisible(true);
    } else {
      setScrollBtnVisible(false);
    }
  };
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  window.addEventListener('scroll', toggleVisibleBtn);
  return (
    <div className="flex flex-col w-full min-h-auto flex-grow min-h-screen">
      <div className="block justify-center">{children}</div>
      {scrollBtnVisible && (
        <Button
          type="default"
          shape="circle"
          className={clsx(
            'fixed bottom-[20px] right-[20px] max-h-[50px] z-50 h-full max-w-[50px] w-full bg-blue border-none hover:bg-black',
            {
              'animate-fadeIn': scrollBtnVisible,
            },
          )}
          onClick={scrollTop}
        >
          <FontAwesomeIcon
            icon={faHandPointUp}
            size="2xl"
            className="text-white"
          />
        </Button>
      )}

      <BugReportButton scrollBtnVisible={scrollBtnVisible} />
    </div>
  );
};
